var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 140,
    viewBox: "0 0 240 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 140,
    rx: 8,
    fill: "#F6F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 51.3333V88.6667H101.333V51.3333H138.667ZM138.667 46H101.333C98.4 46 96 48.4 96 51.3333V88.6667C96 91.6 98.4 94 101.333 94H138.667C141.6 94 144 91.6 144 88.6667V51.3333C144 48.4 141.6 46 138.667 46ZM125.707 69.6267L117.707 79.9467L112 73.04L104 83.3333H136L125.707 69.6267Z",
    fill: "#B8C0CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.47ef898896f6351e5f015057dcf2ef5d.svg";
export { ForwardRef as ReactComponent };